import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { Box, IInputProps, Input } from 'native-base';
import { TextInput } from 'react-native';
import { useTheme } from '@springbig/shared';

export type InputWrapperHandle = {
    focus: () => void;
};

export interface InputWrapperProps extends IInputProps {
    isDate?: boolean;
    value?: string;
    onChangeDate?: (dateString: string) => void;
}

export const InputWrapper = forwardRef<InputWrapperHandle ,InputWrapperProps>(
    ({
        ...props
    }, ref) => {

        const {
            primary,
            field_background,
            field_color,
            field_border,
            field_border_size,
            radius_sm,
        } = useTheme();

        const inputRef = useRef<TextInput>(null);

        useImperativeHandle(ref, () => ({

            focus: () => {

                if (inputRef.current) {
                    inputRef.current.focus();
                }
            },
        }));

        return (
            !props.isDate ?
                <Input
                    ref={inputRef}
                    backgroundColor={field_background}
                    borderColor={field_border}
                    borderWidth={field_border_size}
                    color={field_color}
                    rounded={radius_sm || 0}
                    height={10}
                    fontSize={16}
                    focusOutlineColor={primary}
                    placeholderTextColor={field_color?.slice(0, 7) + '80'}
                    _focus={{
                        borderColor: primary,
                    }}
                    _hover={{
                        borderColor: primary,
                    }}
                    {...props}
                />
                :
                <Box
                    backgroundColor={field_background}
                    borderColor={field_border}
                    borderWidth={field_border_size || 0}
                    borderStyle={'solid'}
                    color={field_color}
                    rounded={radius_sm || 0}
                    height={10}
                    fontSize={16}
                    px={3}
                >
                    <input
                        type={'date'}
                        defaultValue={null}
                        style={{
                            fontSize: 16,
                            fontFamily: 'Roboto',
                            backgroundColor: 'transparent',
                            borderWidth: 0,
                            height: '100%',
                            width: '100%',
                            color: field_color,
                        }}
                        placeholder={'dd-mm-yyyy'}
                        required={true}
                        disabled={props.isReadOnly}
                        max={new Date().toISOString().split('T')[0]}
                        {...props}
                    />
                </Box>
        );
    });

InputWrapper.displayName = 'InputWrapper';

export default InputWrapper;
